<template>
<div class="block breadcrumb">
    <div class="content">
        <router-link :to="$trl({
                  name: 'Home',
                  params: {
                      locale: $route.params.locale
                  }
              })">{{ $t('nav.home') }}
        </router-link>
        <h1><span :key="i" v-for="(bread, i) in $route.meta.breadcrumb"> — <router-link
            :to="$trl({
                  name: bread.name,
                  params: {
                      locale: $route.params.locale,
                      slug: breadcrumb.endRoute ? (bread.subquery ? (subpost(bread).customslug || subpost(bread).slug) : $route.params.slug) : '..',
                      technique: $route.params.technique
                  }
              })">{{ bread.i18n ? $t(bread.i18n) :  breadcrumb.endRoute ? (bread.query ? breadcrumb.endRoute.name : subpost(bread).name) :'..'  }}</router-link>
        </span></h1>
    </div>
    <div class="sharer" @click="share = !share" v-if="$route.name !== 'Article'">
        <span :class="['caption', {
                sharing: share
             }]">{{$t('cta.share')}}</span>
        <transition>
            <div class="share-list" v-if="share">
                <a :href="`https://www.linkedin.com/sharing/share-offsite/?url=${currentLink}`" class="share-link" target="_blank" @click="(e) => open(e, `https://www.linkedin.com/sharing/share-offsite/?url=${currentLink}`, 'LinkedIn')">
                    <IconLinkedin class="logo linkedin" />
                </a>
                <a :href="`https://www.facebook.com/sharer.php?u=${currentLink}`" class="share-link" target="_blank" @click="(e) => open(e, `https://www.facebook.com/sharer.php?u=${currentLink}`, 'Facebook')">
                    <IconFacebook class="logo facebook" />
                </a>
                <a :href="`http://www.twitter.com/share?url=${currentLink}`" class="share-link" target="_blank" @click="(e) => open(e, `http://www.twitter.com/share?url=${currentLink}`, 'Twitter')">
                    <IconTwitter class="logo twitter" />
                </a>
            </div>
        </transition>
        <IconShare />
    </div>
</div>
</template>

<script>
import {
    breadcrumb
} from '@/store/index.js'
import IconShare from '@/components/IconShare'
import IconYoutube from '@/components/IconYoutube'
import IconLinkedin from '@/components/IconLinkedin'
import IconFacebook from '@/components/IconFacebook'
import IconTwitter from '@/components/IconTwitter'
export default {
    components: {
        IconShare,
        IconYoutube,
        IconLinkedin,
        IconFacebook,
        IconTwitter
    },
    data() {
        return {
            breadcrumb,
            share: false,
            currentLink: process.env.VUE_APP_URL + this.$router.currentRoute.path
        }
    },
    methods: {
        open(e, url, domain) {
            e.preventDefault()
            window.open(url, domain, 'height=450, width=550, top=' + (window.innerHeight / 2 - 275) + ', left=' + (window.innerWidth / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
        },
        subpost(query) {
            const post = this.breadcrumb.endRoute.content.find(_ => _.type === query.type)
            return post
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.breadcrumb
    font-size: 17px
    color: #ff2b2a
    font-weight: 500
    min-height: 2.9411764706
    line-height: 1.2
    display: flex
    align-items: center
    @include media-breakpoint-down($lg)
        padding-bottom: 106 / 750 * 100%
    @media print
        padding-bottom: 0
        margin-bottom: .6cm
    @include media-breakpoint-down($sm)
        font-size: 11px
    .home-view &
        display: none
.content
    flex: 1
    @include media-breakpoint-up($lg)
        margin-right: 7em

    h1
        display: inline
a
    text-decoration: none
.sharer
    margin-right: -5.9375%
    display: flex
    align-items: center
    cursor: pointer
    position: relative
    @include media-breakpoint-down($lg)
        display: none
    svg
        margin-left: 24px
        width: 24px
    .share-list
        display: flex
        overflow: hidden
        &.v-enter-active
            transition: visibility 1s
        &.v-leave-active
            transition: visibility 1s
            a
                transition: transform .625s cubic-bezier(.65,0,.25,1)

        &.v-enter
            a
                opacity: 0
                transform: translateY(100%)

        &.v-leave-to
            a
                transform: translateY(-100%)
    a
        display: flex
        transition: opacity .39s .2s, transform .625s cubic-bezier(.65,0,.25,1) .2s
        svg
            width: 16px
            /deep/ path
                fill: #ff2b2a
        &:nth-child(2)
            transition-delay: .25s, .25s
        &:nth-child(3)
            transition-delay: .3s, .3s
        &:hover
            .linkedin
                /deep/ path
                    fill: #0a65c2
            .twitter
                /deep/ path
                    fill: #00acee
            .facebook
                /deep/ path
                    fill: #3b5998
    .caption
        position: absolute
        right: 48px
        transition: transform .625s cubic-bezier(.65,0,.25,1)
        &.sharing
            transform: translateX(-130px)
</style>
